import { getFileImageInfo } from 'utils/getImage';

export function validatorLazadaImage(file: File) {
  return getFileImageInfo(file)
    .then(({ width, height }): any => {
      const max = Math.max(width, height);
      if (max > 5000) {
        return 'lazada-image-size-tips';
      }
    })
    .catch(() => {});
}
